module.exports={render:function (){with(this) {
  return _h('tbody', {
    attrs: {
      "id": id
    }
  }, [(products) && _l((products), function(product, index) {
    return _h('product', {
      key: product.id,
      attrs: {
        "product": product,
        "position-number": index + 1,
        "index": index
      },
      on: {
        "remove": removeProduct,
        "change": changeProduct
      }
    })
  })])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products/InvoiceList.vue
 ** module id = 173
 ** module chunks = 2
 **/